const handleEmailTemplateClick = () => {
  const baseUrl = window.location.origin;
  window.open(`${baseUrl}/template`, "_blank");
};

export const homeRoutes = {
  name: "Dashboard",
  to: "/",
  exact: true
};

export const dashboardRoutes = () => {
  let subMenu = {
    name: "CMS",
    to: "/shows/list",
    icon: "edit",
    children: [],
  };

  if (localStorage.getItem("role_id") != 8 && localStorage.getItem("role_id") != 7) {
    subMenu.children.push({ to: "/category/list", name: "Genre", icon: "code-branch" });
  }

  if (localStorage.getItem("role_id") != 7) {
    subMenu.children.push({ to: "/shows/list", name: "Shows", icon: "video" });
    subMenu.children.push({ to: "/videos/list", name: "Videos", icon: "video" });
    if (getPublisherConfigInfo("collection_needed") === "True") {
      subMenu.children.push({ to: "/collections/list", name: "Collections", icon: "video" });
    }
    if (getPublisherConfigInfo("vertical_shows_needed") === "True" && localStorage.getItem("role_id") != 8) {
      subMenu.children.push({
        to: "/vertical-shows/list",
        name: "Vertical Shows",
        icon: "list"
      });
    }
    if (localStorage.getItem("role_id") != 8) {
      subMenu.children.push({ to: "/podcast/list", name: "Podcast", icon: "audio" });
    }
    
    subMenu.children.push({ to: "/desktop-upload", name: "Upload to Wasabi", icon: "upload" });

  }
  if (localStorage.getItem("role_id") != 8 && localStorage.getItem("role_id") != 7) {
    subMenu.children.push({ to: "/banner/list", name: "Banner", icon: "image" });
    subMenu.children.push({ to: "/newarrivals/order", name: "New Arrivals Order", icon: "video" });
  }
  if (getPublisherConfigInfo("new_arrivals_video_order_needed") == "True" && localStorage.getItem("role_id") != 8 && localStorage.getItem("role_id") != 7) {
    subMenu.children.push({ to: "/newarrivals/episode/order", name: "New Arrivals Episode Order", icon: "video" });
  }
  if (getPublisherConfigInfo("film_of_the_day_needed") == "True" && localStorage.getItem("role_id") != 8 && localStorage.getItem("role_id") != 7) {
    subMenu.children.push({ to: "/filmoftheweek/order", name: "Film of the week", icon: "video" });
  }

  if (getPublisherConfigInfo("partner_needed") == "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/partner/list",
      name: "Partners ",
      icon: "user"
    });
  }

  if (getPublisherConfigInfo("news_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/news/list",
      name: "News ",
      icon: "user",
    });
  }
  if (getPublisherConfigInfo("shorts_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/shorts/list",
      name: "Shorts ",
      icon: "user",
    });
  }
  if (getPublisherConfigInfo("event_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/event/list",
      name: "Events",
      icon: "user",
    });
  }
  if (localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/blog/list",
      name: "Blog",
      icon: "list",
    });
  }
  if (getPublisherConfigInfo("magazine_needeed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/magazine/list",
      name: "Magazine",
      icon: "list",
    });
  }
  if (localStorage.getItem("role_id") !== 7 && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/transcoderstatus/table",
      name: "Transcoder Queue",
      icon: "table",
    });
  }
  if (getPublisherConfigInfo("recording_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/recordings/table",
      name: "Recordings",
      icon: "table",
    });
  }
  if (getPublisherConfigInfo("catchup_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/catchup/list",
      name: "Catchup (Beta)",
      icon: "table",
    });
  }

  if (getPublisherConfigInfo("comments_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/comments/list",
      name: "Comments",
      icon: "table",
    });
  }


  if (getPublisherConfigInfo("playlist_needed") === "True") {
    subMenu.children.push({
      to: "/playlist_section/list",
      name: "Playlist",
      icon: "list",
    });
  }
  if (localStorage.getItem("role_id") === "5") {
    subMenu.children.push({
      to: "/language/mapping",
      name: "Language",
      icon: "table",
    });
  }
  if (getPublisherConfigInfo("b2b_needed") === "True") {
    subMenu.children.push({
      to: "/b2b/list",
      name: "Business to Business",
      icon: "list",
    });
  }
  if (getPublisherConfigInfo("calendar_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/calendar/list",
      name: "Calendar",
      icon: "video"
    });
  }
  if (getPublisherConfigInfo("bookend_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/bookend/list",
      name: "Bookends",
      icon: "video"
    });
  }
  if (getPublisherConfigInfo("custom_filter_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/custom-filter/list",
      name: "Custom Filter",
      icon: "list"
    });
  }
  if (getPublisherConfigInfo("xmlcontent_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({ to: "/xml-import", name: "Import Content", icon: "upload" });
  }

  if (getPublisherConfigInfo("smarthome_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({ to: "/smartHome/list", name: "Smart Home" });
  }

  return subMenu;
};


export const reportRoutes = {
  name: "Reports",
  to: "/report/cancel_report",
  icon: "poll",
  children: []
};

export const scheduleRoutes = {
  name: "Live",
  to: "/schedule",
  icon: "copy",
  ...(localStorage.getItem("role_id") == 8 ? {
    children: [
      { to: "/linearChannel/list", name: "Fast Channel" }
    ]
  } : {
    children: [
      { to: "/linearChannel/list", name: "Fast Channel" },
      { to: "/linearEvent/list", name: "Live Event" },
      { to: "/filler-video/list", name: "Filler Video" },
    ]
  }),
};

export const bookshopRoutes = {
  name: "Shop",
  to: "/bookshop",
  children: [
    { to: "/books/list", name: "Books" },
    { to: "/book-orders/list", name: "Orders" },
    { to: "/book-orders/back", name: "Back Orders" },
  ]
};


export const demandReports = {
  name: "Reports",
  to: "/demandSource/list",
  icon: "poll",
  children: [
    { to: "/demandReport", name: "Demand " },
    { to: "/report/revenues_report", name: "Revenue " },
    { to: "/campaignReport", name: "Campaign " }
  ]
};

export const adsText = {
  name: "Ads Text",
  to: "/adtext/list",
  icon: "list",
  children: [{
    to: "/adtext/list",
    name: "Ad Text",
    icon: "list",
  }]
}

export const demands = {
  name: "Demands",
  to: "/demandSource/list",
  icon: "book",
  children: [
    { to: "/demandPartner/list", name: "Partners" },
    { to: "/demandSource/list", name: "Demands" },
    { to: "/demandMapping", name: "Mapping" }
  ]
};

export const campaign = {
  name: "Campaigns",
  to: "#",
  icon: ["fab", "hotjar"],
  children: [
    { to: "/advertiser/list", name: "Advertisers" },
    { to: "/campaign/list", name: "Campaigns" }
  ]
};

export const avod = {
  name: "AVOD",
  to: "#",
  icon: "poll",
  children: [
    ...(localStorage.getItem("superadmin") ? [{
      name: "Demands",
      to: "/demandSource/list",
      icon: "book",
      children: [
        { to: "/demandSource/list", name: "Demand List" },
        { to: "/demandPartner/list", name: "Demand Partner List" },
        { to: "/demandMapping", name: "Demand Mapping" }
      ]
    }] : []),
    {
      name: "Campaigns",
      to: "#",
      icon: ["fab", "hotjar"],
      children: [
        { to: "/advertiser/list", name: "Advertiser" },
        { to: "/campaign/list", name: "Campaign" }
      ]
    },
    {
      name: "Reports",
      to: "/demandSource/list",
      icon: "poll",
      children: [
        { to: "/demandReport", name: "Demand " },
        { to: "/report/revenues_report", name: "Revenue " },
        { to: "/campaignReport", name: "Campaign " }
      ]
    },
    {
      name: "Ads Text",
      to: "/adtext/list",
      icon: "list",
      children: [{
        to: "/adtext/list",
        name: "Ad Text",
        icon: "list",
      }]
    }
  ]
};


export const newAnalyticsRoutes = {
  name: "Analytics",
  to: "/new-analytics",
  icon: "chart-bar",
  children: [
    { to: "/new-analytics/viewership", 
      name: "Viewership",
      aiAgent: "analytics-viewership-report",
    
      aiAgentContext: "analytics",
      aiAgentIgnoreFor: ["subscription report"],},
    { 
      to: "/new-analytics/subscriptions", 
      name: "Subscriptions",
      aiAgent:
        "analytics-subscription-report",

      aiAgentContext:
        "analytics",

      aiAgentKeywords: [
        "report",
        "analytics",
        "subscription report",
        "today report",
        "view full report"
      ]
    },
    // { 
    //   to: "/new-analytics/trial-conversions", 
    //   name: "Trial IQ",
    //   aiAgent:
    //     "analytics-freetrial-report",
    //   aiAgentContext:
    //     "analytics",
    //   aiAgentKeywords: [
    //     "report",
    //     "analytics",
    //     "subscription free trial report",
    //   ]
    // },
    { to: "/new-analytics/avod", name: "AVOD Performance" },
    // { to: "#", name: "Miscellaneous", children: [] },
  ],
};

// export const userConfigSettings = {
//   name: "Config",
//   to: "/config/add",
//   icon: "cog",
//   children :[]
// }

export const populateMiscellaneousSubMenu = () => {
  const miscellaneousSubMenu = newAnalyticsRoutes.children.find(item => item.name === "Miscellaneous");
  const isNotRole8 = localStorage.getItem("role_id") != 8;
  const isRole14 = localStorage.getItem("role_id") == 14;
  const localRoleNot8 = localStorage.getItem("role_id") != 8;
  const miscSubMenuChildren = [];
  if (isNotRole8) {
    miscSubMenuChildren.push(
      { to: "/report/userdetail_report", name: "User Details " },
      { to: "/report/total_active_user_report", name: "Active Users " },
      { to: "/report/community_active_user_report", name: "Community Users " },
      { to: "/report/community_post_analytics_report", name: "Post Analytics " },
      { to: "/report/inactive_users", name: "Inactive Users " },
      { to: "/report/app_engage", name: "App Engagement " },
      { to: "/report/totaluser_report", name: "New Users" },
      { to: "/report/completed_video", name: "Video Engagement" },
      { to: "/report/hourly_engagement", name: "Hourly Engagement" },
      { to: "/report/error_report", name: "Error Report" },
      { to: "/report/newsletter_report", name: "Newsletters " },
      { to: "/report/favorite_report", name: "Favorites " },
      { to: "/report/ratings_report", name: "Ratings " },
      { to: "/report/event_analytics", name: "Event Analytics" }
    );
    getPublisherConfigInfo('coupon_needed') === 'True' && miscSubMenuChildren.push({ to: "/report/coupon", name: "Coupon" });
    !getPublisherConfigInfo('live_analytics_report_needed') && miscSubMenuChildren.push(
      { to: "/report/liveviews_report", name: "Live Analytics " },
      { to: "/report/category_video", name: "Genre Analytics" }
    );
  }
  getPublisherConfigInfo('data_usage_report_needed') === 'True' && localRoleNot8 && miscSubMenuChildren.push({ to: "/report/datausage", name: "Data Usage" });
  miscSubMenuChildren.push({ to: "/report/vodanalytics_report", name: "VOD Analytics " });
  getPublisherConfigInfo("shorts_needed") === "True" && localRoleNot8 && miscSubMenuChildren.push({ to: "/report/shortsanalytics_report", name: "Shorts Analytics " });
  isRole14 && miscSubMenuChildren.push(
    { to: "/report/donation/direct-debit", name: "Direct Debit" },
    { to: "/report/donation", name: "Donation" }
  );
  getPublisherConfigInfo('live_analytics_report_needed') === 'True' && miscSubMenuChildren.push({ to: "/report/live-analytics-report", name: "Live Analytics" });
  getPublisherConfigInfo("news_needed") === "True" && localRoleNot8 && miscSubMenuChildren.push({ to: "/report/news_analytics", name: "News Analytics" });
  miscellaneousSubMenu.children.push(...miscSubMenuChildren);
};

export const aiAnalyticsRoutes = () => {
  return getPublisherConfigInfo("ai_command_needed") === "True"
    ? { name: "Agentic AI Hub", to: "/ai", icon: "brain" }
    : { name: "", to: "", icon: "" };
}

export const marketing = () => {
  let subMenu = {
    name: "Marketing",
    to: "#",
    icon: "poll",
    children: [],
  };

  subMenu.children.push({ to: "/notifications/list", name: "Push Notifications" });
  if (getPublisherConfigInfo("email_notification_needed") == "True") {
    subMenu.children.push({ onClick: () => { handleEmailTemplateClick() }, name: "Email Campaigns" });
  }

  return subMenu;
}

export const configSettings = () => {
  let subMenu = {
    name: "Settings",
    to: "#",
    icon: "poll",
    children: [],
  };

  if ((getPublisherConfigInfo("config_needed") == "True") || localStorage.getItem("superadmin")) {
    subMenu.children.push({ to: "/config/add", name: "CONFIG" });
  }
  if (localStorage.getItem("superadmin")) {
    // subMenu.children.push({ to: "/config/add", name: "CONFIG" });
    subMenu.children.push({ to: "/gizmott/config/add", name: "GIZMOTT CONFIG" });
    subMenu.children.push({ to: "/event/streamkey/list", name: "EVENT STREAM KEYS" });
  }
  if ((getPublisherConfigInfo("home_config_needed") == "True") || localStorage.getItem("superadmin")) {
    subMenu.children.push({ to: "/config/home-config", name: "HOME CONFIG" });
  }
  if ((getPublisherConfigInfo("menu_config_needed") == "True") || localStorage.getItem("superadmin")) {
    subMenu.children.push({ to: "/config/menu-settings", name: "MENU CONFIG" });
  }

  return subMenu;
}
export const contentPartnerAvod = () => {
  let subMenu = {
    name: "AVOD",
    to: "#",
    icon: "poll",
    children: [],
  };

  subMenu.children.push({ to: "/report/revenues_report", name: "Revenue " });

  return subMenu;
};
export const svod = () => {
  let subMenu = {
    name: "SVOD",
    to: "/subscription",
    icon: "poll",
    children: []
  };
  if (getPublisherConfigInfo("content_partner_needed") == "True") {
    subMenu.children.push({ to: "/report/content_partner_revenue_report", name: "Content Partner Revenue Report" });

  }
  if (role_id != 8) {
    subMenu.children.push({ to: "/report/cancel_report", name: "Cancellation " });
    subMenu.children.push({ to: "/report/refund_report", name: "Refund " });
    subMenu.children.push({
      to: "/report/non_renewal_report",
      name: "Non Renewal "
    });
    if (getPublisherConfigInfo("failed_renewal_report_needed") == "True") {
      subMenu.children.push({
        to: "/report/failed_renew_report",
        name: "Failed Renewal "
      });
    }
    subMenu.children.push({
      to: "/report/subscribed_users",
      name: "Subscribed Users"
    });
    if (getPublisherConfigInfo("upgrade_report_needed") == "True") {
      subMenu.children.push({ to: "/report/upgrade_report", name: "Upgrade " });
    }
    subMenu.children.push({ to: "/report/revenue_report", name: "Revenue " });
    (getPublisherConfigInfo('coupon_needed') === 'True' && subMenu.children.push({ to: "/report/coupon_revenue_report", name: "Coupon Revenue " }));
    if (getPublisherConfigInfo("mismatch_report_needed") == "True") {
      subMenu.children.push({
        to: "/report/mis_match_report",
        name: "Mismatch(Hist-Actual) "
      });
    }
    subMenu.children.push({ to: "/report/renewal_report", name: "Renewal " },);
  }
  return subMenu;
};

export const otherReports = () => {
  let subMenu = {
    name: "Analytics",
    to: "/subscription",
    icon: "poll",
    children: [],
  };
  if (role_id != 8) {
    subMenu.children.push({ to: "/report/userdetail_report", name: "User Details " },
      { to: "/report/total_active_user_report", name: "Active Users " },
      { to: "/report/community_active_user_report", name: "Community Users " },
      { to: "/report/community_post_analytics_report", name: "Post Analytics " },
      { to: "/report/inactive_users", name: "Inactive Users " },
      { to: "/report/app_engage", name: "App Engagement " },
      { to: "/report/totaluser_report", name: "New Users" });

  }
  (getPublisherConfigInfo('data_usage_report_needed') === 'True' && localStorage.getItem("role_id") != 8 && subMenu.children.push({ to: "/report/datausage", name: "Data Usage" }))
  subMenu.children.push({ to: "/report/vodanalytics_report", name: "VOD Analytics " });
  subMenu.children.push({ to: "/report/liveviews_report", name: "FAST Analytics " });
  if (getPublisherConfigInfo("shorts_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({ to: "/report/shortsanalytics_report", name: "Shorts Analytics " });
  }
  if (role_id == 14) {
    subMenu.children.push({ to: "/report/donation/direct-debit", name: "Direct Debit" });
    subMenu.children.push({ to: "/report/donation", name: "Donation" });
  }

  if (role_id != 8 && !getPublisherConfigInfo('live_analytics_report_needed')) {
    subMenu.children.push({ to: "/report/liveviews_report", name: "Live Analytics " },
      { to: "/report/category_video", name: "Genre Analytics" });

  }

  if (role_id != 8) {
    subMenu.children.push({ to: "/report/completed_video", name: "Video Engagement" });
    subMenu.children.push({ to: "/report/hourly_engagement", name: "Hourly Engagement" });
    (getPublisherConfigInfo('coupon_needed') === 'True' && subMenu.children.push({ to: "/report/coupon", name: "Coupon" }))
  }
  (getPublisherConfigInfo('live_analytics_report_needed') === 'True' && subMenu.children.push({ to: "/report/live-analytics-report", name: "Live Analytics" }))
  if (role_id != 8) {
    subMenu.children.push(
      { to: "/report/error_report", name: "Error Report" },
      { to: "/report/newsletter_report", name: "Newsletters " },
      { to: "/report/favorite_report", name: "Favorites " },
      { to: "/report/ratings_report", name: "Ratings " },
      { to: "/report/event_analytics", name: "Event Analytics" }
    )
  }
  if (getPublisherConfigInfo("news_needed") === "True" && localStorage.getItem("role_id") != 8) {
    subMenu.children.push({ to: "/report/news_analytics", name: "News Analytics" });
  }
  return subMenu;
};

export const tvod = () => {
  let subMenu = {
    name: "TVOD",
    to: "#",
    icon: "poll",
    children: [],
  };

  subMenu.children.push({ to: "/report/pay_per_view_report", name: "Pay Per View" });
  if (localStorage.getItem("role_id") != 8) {
    subMenu.children.push({ to: "/report/usage", name: "Usage " });
  }
  return subMenu;
};


export const community = () => {
  return {
    name: "Community",
    to: "#",
    icon: "users",
    children: [
      { to: "/community/posts", name: "Posts" },
      { to: "/community/categories", name: "Categories" },
      { to: "/community/challenges", name: "Challenges" },
    ]
  }
};

export const userManagement = () => {
  let subMenu = {
    name: "User Management",
    to: "#",
    icon: "plug",
    children: []
  };
  if (getPublisherConfigInfo("find_users_needed") == "True") {
    subMenu.children.push({
      to: "/operations/UserManagment",
      name: "User List"
    });
    // subMenu.children.push({
    //   to: "/operations/export-history",
    //   name: "Export History"
    // });
  }
  subMenu.children.push({ to: "/user/password/reset", name: "Reset Password" });

  if (localStorage.getItem("role_id") != 8) {
    subMenu.children.push({
      to: "/freeuser/add",
      name: "Free User ",
      icon: "user",
    });
  }

  return subMenu;
};

export const master = () => {
  let subMenu = {
    name: "Master",
    to: "#",
    icon: "lock",
    children: []
  };
  if (localStorage.getItem("role_id") != 7 && localStorage.getItem("superadmin")) { subMenu.children.push({ to: "/app/list", name: "Apps", icon: "list" }) }
  if (getPublisherConfigInfo("content_partner_needed") == "True") {
    subMenu.children.push({ to: "/content/partner/list", name: "Content Partner", icon: "list" });
  }


  if (getPublisherConfigInfo("subscriptions_needed") == "True") {
    subMenu.children.push({
      to: "/subscription/list",
      name: "Subscription",
      icon: "list",
      aiAgent: "master-subscription-list",

      aiAgentContext: "master",

      aiAgentIgnoreFor: [
        "report",
        "analytics",
        "view report",
        "subscription report"
      ]
    });
  }
  if (getPublisherConfigInfo("token_bundles_needed") == "True" ) {
    subMenu.children.push({
      to: "/bundles/list",
      name: "Token Bundles",
      icon: "list"
    });
  }
  getPublisherConfigInfo('coupon_needed') === 'True' && subMenu.children.push({
    to: "/coupon/list",
    name: "Coupons",
    icon: "list",
  });
  getPublisherConfigInfo('gift_needed') === 'True' && subMenu.children.push({
    to: "/gift/list",
    name: "Gift",
    icon: "gift"
  });
  if (localStorage.getItem("role_id") != 7) {
    if (localStorage.getItem("superadmin")) {
      subMenu.children.push({ to: "/channel/list", name: "Channel", icon: "list" });
    }
    subMenu.children.push({
      to: "/feed/list",
      name: "Feed Management",
      icon: "list",
    });
  }

  if (getPublisherConfigInfo("screening_needed")) {
    subMenu.children.push({
      to: "/screening/list",
      name: "Screening Users",
      icon: "list",
    });
  }

  if (localStorage.getItem("role_id") == 7) {
    subMenu.children.push({
      to: "/super-admin/publisher-list",
      name: "Publishers",
      icon: "list",
    });
  }

  return subMenu;
};

export const AnalyticsRoutes = () => {
  let subMenu = {
    name: "Analytics",
    to: "#",
    icon: "poll",
    children: []
  };
  if (localStorage.getItem("role_id") == 7) {
    subMenu.children.push({ to: "/report/datausage", name: "Data Usage" });
  }
  return subMenu;
}

export const Ecommerce = () => {
  return {
    name: "Flixbuy",
    to: "/report/",
    icon: "poll",
    children: [
      { to: "/ecommerce/category/list", name: "Category", icon: "video" },
      { to: "/ecommerce/video/list", name: "Video", icon: "video" },
      { to: "/ecommerce/show/list", name: "Show", icon: "video" },
      { to: "/playlist/list", name: "Playlist", icon: "list" },
      { to: "/ecom/schedule", name: "Schedule", icon: "list" },
      { to: "/merchant/list", name: "Merchant", icon: "list" },
      { to: "/product/list", name: "Products", icon: "code-branch" },
      { to: "/influencer/list", name: "Influencer", icon: "list" },
      { to: "/ecommerce/banner/list", name: "Banner", icon: "list" },
      { to: "/ecommerce/influencer", name: "Influencer Event", icon: "list" },
      { to: "/flixbuy/live", name: "Live Event", icon: "list" },
      { to: "/salesChannel/list", name: "Sales channel", icon: "video" },
      { to: "/post/list", name: "Post", icon: "video" },
      { to: "/settings", name: "Settings", icon: "video" }
    ]
  }
}

export const EcommerceAnalytics = () => {
  return {
    name: "E-commerce Analytics",
    to: "/report/",
    icon: "poll",
    children: [
      { to: "/report/order", name: "Order Report" },
      { to: "/report/ecom/productview", name: "Product View Report" },
      { to: "/report/ecom/category_productview", name: "Product View Category Report" },
      { to: "/report/ecom/event_report", name: "Event Report" },
      { to: "/report/ecom/user_cart_report", name: "User Cart Report" },
      { to: "/report/ecom/product_video_session", name: "Product Video Session" }
    ]
  }
};

export const affiliateRoutes = {
  name: "Affiliate",
  to: "/",
  exact: true,
  icon: "chart-pie",
  children: [
    {
      to: "/affiliate/list",
      name: "Affiliate⠀",
      exact: true,
    },
    { to: "/report/affiliate", name: "Affiliate Report", exact: true, },
  ],
};


export const FinanceRoute = () => {
  let subMenu = {
    name: "Finance",
    to: "#",
    icon: "poll",
    children: []
  };
  subMenu.children.push({ to: "/report/donation/direct-debit", name: "Direct Debit" });
  subMenu.children.push({ to: "/report/donation", name: "Donation" });
  return subMenu;
}

export const action = () => ({
  name: "Action",
  to: "/live/channel/restart",
  icon: "redo",
  children: []
});

export const uploadContentRoute = () => ({
  name: "Agentic AI Hub",
  icon: "upload",
  children: [

    { to: "/video-upload", name: "Videos" },
    { to: "/shorts-upload", name: "Shorts" },
  ],
});

export const ReelPublisherRoute = () => ({
  name: "Publisher",
  icon: "Publisher",
  children: [
    { to: "/publisher-list", name: " List" }
  ]
});

export const distributionChannelsRoute = () => ({
  name: "Distribution Channels",
  to: "/distribution-channels",
  icon: "network-wired",
});

export const monetizationOptionsRoute = () => ({
  name: "Monetization Options",
  to: "/monetization-options",
  icon: "money-bill-wave",
});

export const dashboardAnalytics = () => ({
  name: "Dashboard Analytics",
  icon: "Dashboard Analytics",
  children: [
    {
      to: "/operator/analytics",
      name: "Revenue Analytics",
      exact: true,
    },
    {
      to: "/operator/appengage",
      name: "App Engagement",
      exact: true,
    },
  ]
});

export const appOnBoarding = () => ({
  name: "App OnBoarding",
  to: "/app-onboarding",
  icon: "App OnBoarding",
});

export const statusControl = () => ({
  name: "Status & Control",
  to: "/status-control",
  icon: "Status Control",
});

const getPublisherConfigInfo = keyName => {
  let response = false;
  if (localStorage.getItem("publisherConfig") && (typeof localStorage.getItem("publisherConfig") !== 'undefined' && (localStorage.getItem("publisherConfig") !== 'undefined'))) {
    var publisherConfig = JSON.parse(localStorage.getItem("publisherConfig"));
    if (publisherConfig && publisherConfig?.length > 0) {
      let configInfo = publisherConfig.filter(i => keyName == i.key_name);
      response = configInfo[0] && configInfo[0].key_value;
      return response;
    }
  }
  return response;
};


let mainRoutes = [];

const role_id = localStorage.getItem("role_id");
const pubid = localStorage.getItem("pub_id");

// if (!localStorage.getItem("superadmin") && pubid === "50167") {
//   mainRoutes = [];
//   mainRoutes.push(userConfigSettings);
// }

if (role_id == 7) {
  reportRoutes.children.unshift({ to: "/superReport", name: "Super Report" });
  mainRoutes = [homeRoutes, dashboardRoutes(), configSettings(), action()];
}
else if (role_id == 18) {
  mainRoutes = [];
  mainRoutes.push(community());
}
else if (role_id == 13) {
  mainRoutes = [FinanceRoute()];
}
else if (role_id == 14) {
  mainRoutes = [];
  mainRoutes.push(homeRoutes);
  mainRoutes.push(master());
  mainRoutes.push(dashboardRoutes());
  if (getPublisherConfigInfo("linear_needed") == "True") {
    mainRoutes.push(scheduleRoutes);
  }
  if (getPublisherConfigInfo("tvod_needed") == "True") {
    mainRoutes.push(tvod());
  }
  if (getPublisherConfigInfo("avod_needed") == "True") {
    mainRoutes.push(avod);
    mainRoutes.push(contentPartnerAvod());
  }
  if (getPublisherConfigInfo("svod_needed") == "True") {
    mainRoutes.push(svod());
  }
  mainRoutes.push(Ecommerce());
  mainRoutes.push(EcommerceAnalytics());
  mainRoutes.push(otherReports());
  mainRoutes.push(FinanceRoute());
  if (getPublisherConfigInfo("community_needed") == "True") {
    mainRoutes.push(community);
  }
}
else if (role_id == 8) {
  mainRoutes.push(dashboardRoutes());
  mainRoutes.push(homeRoutes);
  mainRoutes.push(otherReports());
  if (getPublisherConfigInfo("tvod_needed") == "True") {
    mainRoutes.push(tvod());
  }
  if (getPublisherConfigInfo("avod_needed") == "True") {
    mainRoutes.push(avod);
    mainRoutes.push(contentPartnerAvod());
  }
  if (getPublisherConfigInfo("svod_needed") == "True") {
    mainRoutes.push(svod());
  }
  if (getPublisherConfigInfo("linear_needed") == "True") {
    mainRoutes.push(scheduleRoutes);
  }
  if (getPublisherConfigInfo("community_needed") == "True") {
    mainRoutes.push(community);
  }
}
else if (role_id == 19) {
  mainRoutes = [];
  mainRoutes.push(ReelPublisherRoute);
} else if (role_id == 20) {
  mainRoutes = [];
  mainRoutes.push(uploadContentRoute);
  mainRoutes.push(distributionChannelsRoute);
  mainRoutes.push(monetizationOptionsRoute);
} else if (role_id == 21) {
  mainRoutes = [];
  mainRoutes.push(dashboardAnalytics);
  mainRoutes.push(appOnBoarding);
  mainRoutes.push(statusControl);
}
else {
  let mainRoutes = [];
  mainRoutes.push(homeRoutes);
  mainRoutes.push(master());
  mainRoutes.push(AnalyticsRoutes())
  mainRoutes.push(dashboardRoutes());
  if (getPublisherConfigInfo("linear_needed") == "True") {
    mainRoutes.push(scheduleRoutes);
  }
  if (getPublisherConfigInfo("tvod_needed") == "True") {
    mainRoutes.push(tvod());
  }
  if (getPublisherConfigInfo("avod_needed") == "True") {
    mainRoutes.push(avod);
    mainRoutes.push(contentPartnerAvod());
  }
  if (getPublisherConfigInfo("svod_needed") == "True") {
    mainRoutes.push(svod());
  }
  mainRoutes.push(Ecommerce());
  mainRoutes.push(EcommerceAnalytics());
  if (localStorage.getItem("superadmin")) {
    mainRoutes.push(configSettings());
  }
  mainRoutes.push(otherReports());
  if (getPublisherConfigInfo("community_needed") == "True") {
    mainRoutes.push(community);
  }
  if (getPublisherConfigInfo("books_needed") == "True") {
    mainRoutes.push(bookshopRoutes);
  }
}

export default mainRoutes;
